export default "__VITE_ASSET__DTS9W0d___"